import { Injectable } from '@angular/core';
import { CommonUtilty } from './commonUtility';

@Injectable({
    providedIn: 'root'
})
export class RuleEngineEvaluatorService {

    constructor(private commonUtility: CommonUtilty) { }

    // Evaluate the rules for OCR verification using tessract.js The rules array is not related to the rules configured in PC application
    evaluateRules(rules, data, rulesOutput) {
        if (this.commonUtility.isArrayIterable(rules)) {
            for (let rule of rules) {
                if (rule.condition(data)) {
                    rulesOutput = rule.action(data, rulesOutput, rule);
                } else {
                    // let failedRuleAction = rule.action(data, rulesOutput)
                    rulesOutput.push({ validationStatus: false, validationMsg: rule.validationMsg, ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight })
                }
            }
        }
        return rulesOutput;
    }
}
